<template>
  <div>
    <main-layout>
      <MainMenu />
      <v-container>
        <div class="primary--text">ข้อมูลการยอมรับ</div>
        <div class="text-xs-right">
          <v-btn dark depressed color="primary" @click="showAdvancedSearch = !showAdvancedSearch">
            <v-icon>search</v-icon>
            &nbsp;
            {{ $t('advanced search') }}&nbsp;
            <i v-if="!showAdvancedSearch" class="fas fa-angle-down"></i>
            <i v-else class="fas fa-angle-up"></i>
          </v-btn>
          <v-btn dark outline color="primary" :loading="loading" @click="handleExportXlsx">
            <i class="fas fa-file-export"></i>&nbsp;{{ $t('export') }}
          </v-btn>
        </div>
        <div
          v-if="showAdvancedSearch"
          class="mb-4 py-2"
          style="border: 1px solid #eee; border-radius: 10px; position: relative"
        >
          <v-layout wrap class="form-control">
            <v-flex xs6 px-2>
              <div class="caption">Terms & Conditions</div>
              <multiselect
                v-model="filter.term_condition_id"
                :options="filterTermOptions"
                :searchable="false"
                :allow-empty="true"
                track-by="name"
                label="name"
                select-label
                selected-label
              >
              </multiselect>
            </v-flex>
            <v-flex xs6 px-2>
              <div class="caption">รหัสสมาชิก</div>
              <input v-model="filter.member_id" type="text" placeholder="รหัสสมาชิก" />
            </v-flex>
            <v-flex xs6 px-2>
              <div class="caption">ชื่อ-สกุล</div>
              <input v-model="filter.name" type="text" placeholder="ชื่อ-สกุล" />
            </v-flex>
            <v-flex xs6 px-2>
              <div class="caption">เบอร์โทร</div>
              <input v-model="filter.phone_number" type="text" placeholder="เบอร์โทร" />
            </v-flex>
            <v-flex xs6 px-2>
              <div class="caption">อีเมล</div>
              <input v-model="filter.email" type="text" placeholder="อีเมล" />
            </v-flex>
            <v-flex xs12 class="text-xs-right">
              <v-btn outline color="grey" @click="handleClearSearch">{{
                $t('Clear Search')
              }}</v-btn>
              <v-btn depressed color="primary" @click="handleSearch">
                <i class="fas fa-search mr-1"></i>
                {{ $t('Search') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <v-data-table
          hide-actions
          :loading="loading"
          :headers="headers"
          :items="data"
          :pagination.sync="pagination"
          class="elevation-1 mt-3"
        >
          <template #items="props">
            <tr>
              <td>{{ props.item.term_condition_name || '-' }}</td>
              <td>{{ props.item.member_id || '-' }}</td>
              <td>{{ props.item.name || '-' }}</td>
              <td>{{ props.item.phone_number || '-' }}</td>
              <td>{{ props.item.email || '-' }}</td>
              <td>{{ props.item.line || '-' }}</td>
              <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
            </tr>
          </template>
        </v-data-table>
        <div class="mt-2">
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pagelength"
            @input="handleChangePage"
          ></v-pagination>
        </div>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import { mapGetters } from 'vuex'
import MainMenu from './MainMenu'
import * as XLSX from 'xlsx'
import moment from 'moment'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    MainMenu,
    Multiselect
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      showAdvancedSearch: false,
      loading: false,
      filter: {},
      data: [],
      headers: [
        {
          text: 'Terms & Conditions',
          value: 'term_condition_name',
          sortable: false
        },
        { text: 'รหัสสมาชิก', value: 'member_id', sortable: false },
        { text: 'ชื่อ-สกุล', value: 'name', sortable: false },
        { text: 'เบอร์โทร', value: 'phone_number', sortable: false },
        { text: 'อีเมล', value: 'email', sortable: false },
        { text: 'ไลน์', value: 'line', sortable: false },
        { text: 'วันที่', value: 'timestamp', sortable: false }
      ],
      isExport: false,
      termsMasterData: []
    }
  },

  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    filterTermOptions() {
      let options = []
      if (this.termsMasterData && this.termsMasterData.length > 0) {
        this.termsMasterData.map((term) => {
          options.push({ id: term.id, name: term.name })
        })
      }

      return options
    }
  },
  mounted() {
    this.handleGetAgreeTermsAndConditions()
    this.getTermAndConditions()
  },
  methods: {
    async handleGetAgreeTermsAndConditions() {
      const vm = this
      try {
        const response = await vm.getAgreeTermsAndConditions()
        if (response && response.status === 200) {
          vm.data = response.data.data
          vm.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getAgreeTermsAndConditions() {
      const vm = this
      try {
        const limit = vm.isExport ? vm.total : vm.limit
        let data = {
          page_id: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset
        }

        if (vm.filter && vm.filter.term_condition_id) {
          Object.assign(data, { term_condition_id: vm.filter.term_condition_id.id })
        }
        if (vm.filter && vm.filter.member_id) {
          Object.assign(data, { member_id: vm.filter.member_id })
        }
        if (vm.filter && vm.filter.name) {
          Object.assign(data, { name: vm.filter.name })
        }
        if (vm.filter && vm.filter.phone_number) {
          Object.assign(data, { phone_number: vm.filter.phone_number })
        }
        if (vm.filter && vm.filter.email) {
          Object.assign(data, { email: vm.filter.email })
        }

        vm.$store.dispatch('loading')
        const response = await toaCrmApi.getAgreeTermsAndConditions({
          config: {
            params: data
          }
        })
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleExportXlsx() {
      const vm = this
      vm.isExport = true
      const tempDate = await vm.getAgreeTermsAndConditions()
      const data = tempDate.data.data
      vm.isExport = false

      if (data == null) return
      const objData = data.map((el) => {
        return {
          terms_conditions: el.term_condition_name,
          member_id: el.member_id,
          name: el.name,
          phone_number: el.phone_number,
          email: el.email || '-',
          timestamp: el.timestamp ? moment(el.timestamp).format('DD/MM/YYYY') : '-'
        }
      })

      const heading = [
        ['Terms & Conditions', 'รหัสสมาชิก', 'ชื่อ-สกุล', 'เบอร์โทร', 'อีเมล', 'วันที่']
      ]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, objData, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `agree-terms-conditions.xlsx`)
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        if (vm.pageNumber != 1) {
          vm.offset + 1
        }
        vm.handleGetAgreeTermsAndConditions()
      }
    },
    reset() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleGetAgreeTermsAndConditions()
    },
    handleChangeSort() {
      this.reset()
    },
    async getTermAndConditions() {
      const vm = this
      let data = {
        page_id: vm.selectedBot.pageid,
        limit: 100,
        offset: 0
      }

      const response = await toaCrmApi.getTermAndConditions({ config: data })
      if (response && response.status === 200) {
        vm.termsMasterData = response.data.data
      }
    },
    handleClearSearch() {
      this.filter = {}
      this.showAdvancedSearch = false
      this.reset()
    },
    handleSearch() {
      this.reset()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/TermsAndConditions/AgreeTermsAndConditions.vue